import * as React from 'react'
import imageDoodleRond from '../../assets/img/doodle_rond.png'
import imageDoodleLigne from '../../assets/img/doodle_ligne0.png'

interface ITitleProps {
  subtitle?: boolean
  children: React.ReactNode
}

const Title: React.FC<ITitleProps> = ({ subtitle = false, children }) => {
  return (
    <div className={`title ${subtitle ? 'title--subtitle' : 'title--main'}`}>
      {subtitle ? (
        <h3 className="title__h3" style={{ backgroundImage: `url(${imageDoodleLigne})` }}>
          {children}
        </h3>
      ) : (
        <h2 className="title__h2" style={{ backgroundImage: `url(${imageDoodleRond})` }}>
          {children}
        </h2>
      )}
    </div>
  )
}

export default Title



// WEBPACK FOOTER //
// ./src/components/Title/Title.tsx